<template>
	<div>
		<div class="doctorPage managerPlan">
			<div class="selectSearch">
				<el-form ref="form" :model="sampleReportForm" class="qcFrom searchConditions" :inline="true">
					<el-form-item label="任务编号" prop="SamplingTaskId">
						<el-input v-model="sampleReportForm.SamplingTaskId" class="name" placeholder="请输入任务编号" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="报告编号" prop="AccNo">
						<el-input v-model="sampleReportForm.AccNo" class="name" placeholder="请输入报告编号" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="中心名称" prop="HospitalName">
						<el-input v-model="sampleReportForm.HospitalName" class="name" placeholder="请输入中心名称" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="抽样医生" prop="DoctorName">
						<el-input v-model="sampleReportForm.DoctorName" class="name" placeholder="请输入抽样医生" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="专家姓名" prop="ExpertName">
						<el-input v-model="sampleReportForm.ExpertName" class="name" placeholder="请输入专家姓名" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="设备类型" prop="modalityType">
					    <el-select v-model="sampleReportForm.modalityType" placeholder="请选择设备类型" size="mini" style="width:160px" >
					      <el-option v-for="item in modalityTypeSelect" :key="item.text" :label="item.text" :value="item.text" >{{item.text}}</el-option>
					    </el-select>
					</el-form-item>
					<el-form-item class="marl18 fontwun">
						<el-checkbox-group v-model="sampleReportForm.isUnqualified">
							<el-checkbox :label="true">不合格</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item class="marl18 fontwun">
						<el-checkbox-group v-model="sampleReportForm.IsSerious">
							<el-checkbox :label="true">严重扣分项</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search" round>查询</el-button>
						<el-button type="primary" class="resetBtn" @click="resetForm('form')">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="contentBigBox">
			<el-row :gutter="30" v-loading="selfLoading">
				<el-col :span='tootipType?12:24'>
					<el-table class="qcTable haveFilterTable" ref="multipleTable" @sort-change="sortChange" :data="reportListByTaskVal" highlight-current-row>
						<el-table-column width="140" prop="HospitalName" label="中心名称" column-key="HospitalUid" ></el-table-column>
						<el-table-column prop="ModalityType" label="抽样医生">
							<template slot-scope="scope">
								<span v-if="scope.row.SubjectType == 4">{{scope.row.ReportSubmitterName}}</span>
								<span v-if="scope.row.SubjectType == 2">{{scope.row.FirstApproverName}}</span>
								<span v-if="scope.row.SubjectType == 3">{{scope.row.TechnictionName}}</span>
								<!-- <span v-if="scope.row.ModalityType!='US'">{{scope.row.FirstApproverName}}</span>
								<span v-else>{{scope.row.ReportSubmitterName}}</span> -->
							</template>
						</el-table-column>
						<el-table-column prop="SamplingTaskId" min-width="100" label="任务编号" ></el-table-column>
						<el-table-column prop="AccNo" min-width="100" label="报告编号" ></el-table-column>
						<el-table-column prop="ModalityType" column-key='ModalityType' min-width="100" label="设备类型"></el-table-column>
						<el-table-column prop="CheckingItems" min-width="120" label="检查项目" ></el-table-column>
						<el-table-column prop="ReportScore" label="报告评分" min-width="120" sortable="custom" key='1'></el-table-column>
						<el-table-column prop="ImageScore" label="影像评分" min-width="120" sortable="custom" key='3'></el-table-column>
						<el-table-column prop="DiseaseHistoryScore" label="病史评分" min-width="120" sortable="custom" key='5'></el-table-column>
						<!-- <el-table-column prop="ReportScoreDiff" label="报告分差" key='2' v-if="taskInfo.CategoryName=='报告'||taskInfo.CategoryName=='影像和报告'"></el-table-column>
						<el-table-column prop="ImgScoreDiff" label="影像分差" key='4' v-if="taskInfo.CategoryName=='影像'||taskInfo.CategoryName=='影像和报告'"></el-table-column>
						<el-table-column v-if="taskInfo.DistributionMethod!=''&&taskInfo.DistributionMethod!='未知'&&taskInfo.DistributionMethod!='null'"
						 prop="QCTimes" label="质控进度">
							<template slot-scope="scope">
								<el-tooltip effect="dark" placement="top-start">
									<div class="progress">
										<div class="progress-bar progress-bar-success" :style="`width: ${Math.floor((scope.row.CompleteCount/scope.row.QCTimes)*100)}%`">
										</div>
										<span class="sr-only">{{(Math.floor((scope.row.CompleteCount/scope.row.QCTimes)*100))}}%</span>
									</div>
									<div slot="content" class="tableTooltip">
										<div>
											<em></em>
											<span>已完成数量:{{scope.row.CompleteCount}}</span>
										</div>
									</div>
								</el-tooltip>
							</template>
						</el-table-column> -->
						<el-table-column prop="TotalStatus" label="质控状态" column-key='TotalStatus' min-width="100">
							<template slot-scope="scope">
								<span>{{scope.row.TotalStatus | forTotalStatus}}</span>
								<!-- <span v-if="scope.row.TotalStatus==120">
									已抽样
								</span>
								<span v-if="scope.row.TotalStatus==125">
									进行中
								</span>
								<span v-if="scope.row.TotalStatus==130">
									已完成
								</span> -->
							</template>
						</el-table-column>
						<el-table-column prop="QCPeoPleName" min-width="100" label="专家姓名"></el-table-column>
						<el-table-column prop="QCDt" min-width="100" :formatter="formattertime" label="完成时间"></el-table-column>
						<el-table-column prop="" label="操作" fixed='right' width="180">
							<template slot-scope="scope">
								<span class="tableOpe" v-if="scope.row.TotalStatus<=123" @click="handleClick(scope.row,'table')">查看详情</span>
								<div v-else-if="scope.row.ExpertUserGuids.length<=1">
									<span class="tableOpe" v-if="scope.row.TotalStatus>=125" @click="handleClick(scope.row,'length')">查看结果</span>
								</div>
								<div v-else-if="scope.row.ExpertUserGuids.length>1">
									<span class="tableOpe" @click="handleCurrentChange(scope.row,scope.$index,$event)">查看结果</span>
								</div>
								<span class="tableOpe marl10" v-if="scope.row.TotalStatus==123" @click="changeClick(scope.row)">更换报告</span>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
				<el-col v-show="tootipType" :span="12" class="exporttootip" :style="{minHeight:height}">
					<i ref="toopIcon" class="tootipCaretLeft el-icon-caret-left"></i>
					<div class="title">
						此报告有 {{qcresultsByTaskList.length}} 位专家参与质控 <i class="el-icon-close" @click="closeRbox"></i>
					</div>
					<ul class="qcresultsBox" :style="{height:height,minHeight:'85px'}">
						<li v-for="item in qcresultsByTaskList" :key="item.Name" class="qcresults">
							<el-row>
								<el-col :span='6'>
									专家 : {{item.Name}}
								</el-col>
								<el-col :span='6'>
									报告评分 : {{item.ReportScore}}
								</el-col>
								<el-col :span='6'>
									影像评分 : {{item.ImageScore}}
								</el-col>
								<el-col :span='6'>
									{{item.StatusName}}
								</el-col>
							</el-row>
							<el-row>
								<el-col :span='18'>
									完成时间 : {{item.QCDt}}
								</el-col>
								<el-col :span='6' class="tableOpe">
									<span @click="handleClick(item)">查看详情</span>
								</el-col>
							</el-row>
						</li>
					</ul>
				</el-col>
			</el-row>
			<div class="pages">
				<el-pagination class="pageAll" layout="prev, pager, next" v-anchor="1" :total="totalsecond" :page-size='sampleReportForm.pageCount'
				 :current-page='sampleReportForm.PageIndex' @current-change='currentChange'>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
    import Api from '../../api'
	import axios from '@/js/api'
	// import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		data() {
			return {
				currentRow: null,
				height: 0,
				datas: {},
				sampleReportForm: {
					"SamplingTaskId": "",
					"AccNo": "",
					"HospitalName": "",
					"DoctorName": "",
					"ModalityType": "",
					"pageIndex": 1,
					"pageCount": 10,
					"isUnqualified":false,
					"IsSerious":false,
					"SortCatagory":0,
					"SortType":0
				},
				reportListByTaskVal:[],
				totalsecond:0,
				selfLoading:false
			};
		},
		filters: {
		  forTotalStatus: function (value) {
			   return {
				'': '不限',
				'120': '已抽样',
				'123': '已分配',
				'125': '进行中',
				'130': '已完成',
				'140': '申诉中',
				'170': '已归档'
			   } [value] || '不限';
		  },
		},
		computed: {
			...Vuex.mapState('managerPlanList', ['qcresultsList', 'qcresultsByTaskList', 'loading','taskInfo','modalityTypeSelect']),
			...Vuex.mapState('breadcrumb', ['tootipType', 'selectRow'])
		},
		activated(){
			this.setTootipType(false);
			this.GetReportModality()
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setqcresultsShow', 'setTootipType']),
			...Vuex.mapMutations('managerPlanList', ['setLoading', 'currentChangesSecond','changeReportsListMu']),
			...Vuex.mapMutations('doctor', ['setDetailsParameter', 'setDetalLoading']),
			...Vuex.mapActions('managerPlanList', ['GetQCResultsByTask','GetReportModality']),
			...Vuex.mapActions('doctor', ['GetReportDetail']),
			changeClick(row){
				this.changeReportsListMu(row);
				this.$router.push("/home/manager/task/replacementReport");
			},
			getReportList(){
				let _this = this;
				axios.ajaxPost('post',Api.api.manager.GetReportList,this.sampleReportForm).then(res=>{
					_this.reportListByTaskVal = res.data.Reports;
					_this.totalsecond = res.data.TotalCount;
					_this.selfLoading = false;
				})
			},
			// 重置
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			// 搜索
			search(){
				this.sampleReportForm.pageIndex = 1;
				this.selfLoading = true;
				this.getReportList();
			},
			sortChange(column){
				if (column.prop == "ReportScore") {
					this.sampleReportForm.SortCatagory = 1;
				}else{
					this.sampleReportForm.SortCatagory = 2;
				}
				if (column.order == "ascending") {
					this.sampleReportForm.SortType = 1;
				}else{
					this.sampleReportForm.SortType = 2;
				}
				this.search();
			},
			closeRbox() {
				this.setTootipType(false);
				this.$refs.multipleTable.setCurrentRow();
			},
			// 右侧出现专家列表
			handleCurrentChange(val, index, e) {
				this.currentRow = val;
				this.selectRow.index = index;
				this.selectRow.row = val;
				let target = e.target || e.originalTarget || e.toElement || e.path[0];
				let parent = e.currentTarget.parentElement.parentElement;
				if (target.tagName == "SPAN" || target.nodeName == "SPAN") {
					this.setTootipType(true);
					this.datas.ReportGuid = val.ReportGuid;
					this.datas.SamplingTaskGuid = val.SamplingTaskGuid;
					this.GetQCResultsByTask({
						samplingtaskguid: val.SamplingTaskGuid,
						reportGuid: val.ReportGuid
					})
					let difference = parent.offsetHeight / 2;
					this.$refs.toopIcon.style.top = parent.offsetTop + difference + 35 + 'px';
					let ele = document.getElementsByClassName('qcTable')[0];
					if (ele) {
						this.height = (ele.offsetHeight)-60 + 'px';
					}
				}
			},
			// 跳转至详情页
			handleClick(val) {
				let arg = arguments[1];
				this.qcresultsList.Name = val.Name;
				if (arg) {
					this.setqcresultsShow(false);
					if (arg == 'table') {
						this.qcresultsList.expertUserId = '';
					}else{
						this.qcresultsList.expertUserId = val.ExpertUserGuids[0];
					}
					this.qcresultsList.ReportGuid = val.ReportGuid;
					this.qcresultsList.SamplingTaskGuid = val.SamplingTaskGuid;
				} else {
					this.setqcresultsShow(true);
					this.qcresultsList.expertUserId = val.ExpertUserId;
					this.qcresultsList.ReportGuid = this.datas.ReportGuid;
					this.qcresultsList.SamplingTaskGuid = this.datas.SamplingTaskGuid;
				}
				this.setDetalLoading(true);
				this.setDetailsParameter({
					reportGuid: this.qcresultsList.ReportGuid,
					samplingTaskGuid: this.qcresultsList.SamplingTaskGuid,
					ExpertUserGuid: this.qcresultsList.expertUserId
				})
				this.GetQCResultsByTask({
					samplingtaskguid: this.qcresultsList.SamplingTaskGuid,
					reportGuid: this.qcresultsList.ReportGuid
				})
				this.GetReportDetail()
				this.$router.push("/home/manager/scoring");
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			formattertime(row, column, cellValue) {
				if (cellValue != '' && cellValue != null) {
					return cellValue.substring(0, cellValue.length - 3);
				} else {
					return cellValue;
				}

			},
			//分页
			currentChange(val) {
				this.selfLoading = true;
				this.sampleReportForm.pageIndex = val;
				this.selectRow.pageIndex = val;
				this.selectRow.row = val;
				this.setTootipType(false);
				this.currentChangesSecond(val)
				this.getReportList();
			}
		}

	}
</script>
<style scoped>
	.contentBigBox {
		padding-top: 36px;
	}
	.doctorPage .selectSearch .searchConditions{
		width: 100%;
	}
</style>
